import { render, staticRenderFns } from "./v-pill-shape-form.vue?vue&type=template&id=20e3a84a&scoped=true"
import script from "./v-pill-shape-form.vue?vue&type=script&lang=js"
export * from "./v-pill-shape-form.vue?vue&type=script&lang=js"
import style0 from "./v-pill-shape-form.vue?vue&type=style&index=0&id=20e3a84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3a84a",
  null
  
)

export default component.exports